import i18n from '../language/index'
import request from '@/base/request'
import yun_ajax from '@/base/request_yun'
import yun_new_ajax from '@/base/request_yun_new'
import dcl_ajax from '@/base/request_dcl'
import service from '@/base/service'
import console_login from '@/base/console_login'
import Cookies from 'js-cookie'
import moment from 'moment'

export function p_init(data) {
  return request({
    url: '/admin/visual/get',
    method: 'get',
    params: data
  })
}

export function p_save(data) {
  return request({
    url: '/admin/visual/save',
    method: 'post',
    data
  })
}

//文件管理列表页
export const getFolderList = (data) => {
  return request({
    url: '/admin/image',
    method: 'GET',
    params: data
  })
}


//创建文件夹接口
export const createFolder = (data) => {
  return request({
    url: '/admin/image/mkdir',
    method: 'POST',
    data
  })
}


//删除文件夹
export const deleteFolderList = (data) => {
  return request({
    url: '/admin/image/remove',
    method: 'POST',
    data
  })
}

//图片上传接口 暂时只有单张上传
export const imageUpload = (data) => {
  return request({
    url: '/admin/image/imageUpload',
    method: 'POST',
    data
  })
}

// 顶部导航下拉框数据

export const getdirTree = (data) => {
  return request({
    url: '/admin/image/dirTree',
    method: 'POST',
    data
  })
}

//文件移动接口
export const moveFolderlist = (data) => {
  return request({
    url: '/admin/image/move',
    method: 'POST',
    data
  })
}
//文件夹重命名
export const renameFolder = (data) => {
  return request({
    url: '/admin/image/rename',
    method: 'POST',
    data
  })
}

//本地资源库 图片url重构造

export function getHomeData(data) {
  return request({
    url: '/admin/home',
    method: 'GET',
    params: data
  })
}

//文件管理列表页 云端
export const getyunFolderList = (data) => {
  return yun_ajax({
    url: '/file/list',
    method: 'GET',
    params: data,
  })
}
//文件上传 云端
export const uploadyunfile = (data = {}) => {
  if (Object.prototype.toString.call(data) === '[object FormData]') {
    data.append('source', 'jpt')
  } else {
    data.source = 'jpt'
  }
  return yun_ajax({
    url: '/file/upload',
    method: 'POST',
    data
  })
}
//创建文件夹 云端
export const createyunFolder = (data) => {
  return yun_ajax({
    url: '/file/createFolder',
    method: 'POST',
    data
  })
}
//文件夹重命名
export const renameyunFolder = (data) => {
  return yun_ajax({
    url: '/file/rename',
    method: 'GET',
    params: data,
  })
}


//文件夹树结构 云端
export const getyundirtree = (data) => {
  return yun_ajax({
    url: '/file/listFolderTree',
    method: 'GET',
    params: data,
  })
}

//文件批量删除 云端
export const deleteyunImg = (data) => {
  return yun_ajax({
    url: '/file/deleteList',
    method: 'POST',
    data
  })
}
//文件移动 云端
export const moveyunfolder = (data) => {
  return yun_ajax({
    url: '/file/move',
    method: 'POST',
    data
  })
}


//文件搜索 云端
export const searchyunfolder = (data) => {
  return yun_ajax({
    url: '/file/search',
    method: 'GET',
    params: data,
  })
}

export const updateLang = (data) => {
  return yun_new_ajax({
    url: '/ydyl-converge/lang/updateLang',
    method: 'POST',
    data
  })
}

export function addtest() {
  return request({
    url: '/admin/visual/addtest',
    method: 'get',
  })
}

export function delXysTemplet(data) {
  return request({
    url: '/admin/theme/delXysTemplet',
    method: 'get',
    params: data
  })
}

// 复制导航
export function copyNav(data) {
  return request({
    url: '/admin/navigation/create',
    method: 'POST',
    data
  })
}

// 添加导航
export function addNav(data) {
  return request({
    url: '/admin/navigation/create',
    method: 'POST',
    data
  })
}

// 更新导航
export function updateNav(data) {
  return request({
    url: '/admin/navigation/update',
    method: 'POST',
    data
  })
}

// 导航列表
export function navList(data) {
  return request({
    url: '/admin/navigation',
    method: 'GET',
    params: data
  })
}

// 查看导航详情
export function navDetail(data) {
  return request({
    url: '/admin/navigation/detail',
    method: 'GET',
    params: data
  })
}

// 删除导航
export function deleteNav(data) {
  return request({
    url: '/admin/navigation/remove',
    method: 'POST',
    data
  })
}

// 导航下拉列表
export function topNavList(data) {
  return request({
    url: '/admin/navigation/topNavList',
    method: 'GET',
    params: data
  })
}

// 根据站内链接获取导航信息
export function navLinkInfo(data) {
  return request({
    url: '/admin/navigation/linkInfo',
    method: 'GET',
    params: data
  })
}

//切换列表状态
export function quickSwitch(data) {
  return request({
    url: '/admin/navigation/quickSwitch',
    method: 'POST',
    data
  })
}

// 页面导航保存
export function pageNovlist(data) {
  return request({
    url: '/admin/navigation/saveNav',
    method: 'POST',
    data
  })
}

export function addXysTp(data) {
  return request({
    url: '/admin/theme/addXysTp',
    method: 'get',
    params: data,
  })
}

// 获取产品列表
export function getProList(data) {
  return request({
    url: '/admin_cms/goods/getlist',
    method: 'POST',
    data,
  })
}

// 获取产品列表
export function wmRecommend(data) {
  return request({
    url: '/admin_cms/recommend/wmRecommend',
    method: 'POST',
    data,
  })
}

// 删除产品
export function delPro(data) {
  return request({
    url: '/admin_cms/goods/remove',
    method: 'POST',
    data,
  })
}

// 获取产品类型列表
export function getProTypeList() {
  return request({
    url: '/admin_cms/goodsType/getlist',
    method: 'GET'
  })
}

// 获取案例类型列表
export function getArticleTypeList() {
  return request({
    url: '/admin_cms/Category/getlist?type=3',
    method: 'GET'
  })
}

// 获取表单列表
export function getForm(data) {
  return request({
    url: '/admin/form/xyslist',
    method: 'get',
    params: data,
  })
}

// 保存表单
export function saveForm(data) {
  return request({
    url: '/admin/form/xysSave',
    method: 'post',
    data,
  })
}

//获取域名
export function get_host(data) {
  return request({
    url: '/admin/visual/getPreviewAddress',
    method: 'get',
    params: data
  })
}

//获取页面
export function get_pags() {
  return request({
    url: '/admin/page/getlist',
    method: 'get',
  })
}

export function get_QRCcode(data) {
  return request({
    url: '/admin/home/getQrcode',
    method: 'get',
    params: data
  })
}

//获取角色
export function get_home(data) {
  return request({
    url: '/admin/home',
    method: 'get',
  })
}

//素材保存
export function save_material(data) {
  return request({
    url: '/admin/widget/addGroup',
    method: 'post',
    data,
  })
}

//获取素材
export function get_material(data) {
  return request({
    url: '/admin/widget/groupList',
    method: 'get',
    params: data
  })
}

export function get_material_group_count(data) {
  return request({
    url: '/admin/widget/groupCount',
    method: 'get',
    params: data
  })
}

//获取素材详细
export function get_material_detailed(data) {
  return request({
    url: '/admin/widget/getInfo',
    method: 'get',
    params: data
  })
}

//删除素材
export function del_material(data) {
  return request({
    url: '/admin/widget/delGroup',
    method: 'get',
    params: data
  })
}

//锚点保存
export function save_anchor(data) {
  return request({
    url: '/admin/visual/anchor',
    method: 'post',
    data,
  })
}

//获取锚点
export function get_anchor(data) {
  return request({
    url: '/admin/visual/anchor',
    method: 'get',
    params: data
  })
}

//获取表单详情
export function getFormById(id) {
  return request({
    url: '/admin/form/getRow?id=' + id,
    method: 'get'
  })
}

//获取搜索条件列表
export function getSearchsParams(data) {
  return request({
    url: '/admin/search/getParams',
    method: 'get',
    params: data
  })
}

//获取搜索结果列表
export function getSearchsResult(data) {
  return request({
    url: '/admin/search/getlist',
    method: 'post',
    data,
  })
}


//获取图册列表
export function get_atlas(data) {
  return request({
    url: '/admin_cms/album/getlist',
    method: 'get',
    params: data
  })
}
//图册删除

export const delAtlasList = (data) => {
  return request({
    url: '/admin_cms/album/remove',
    method: 'GET',
    params: data
  })
}
//图册保存

export const saveAtlasList = (data) => {
  return request({
    url: '/admin_cms/album/save',
    method: 'POST',
    data
  })
}
//图册编辑

export const editAtlasList = (data) => {
  return request({
    url: '/admin_cms/album/getRow',
    method: 'POST',
    data
  })
}
//右侧展示的分类接口
//type 1:文章 2:帮助 3:案例 4:下载 11:视频,5:图册
export const gettypeList = (data) => {
  return request({
    url: '/admin_cms/Category/getlist',
    method: 'GET',
    params: data
  })
}

//文章分类保存
export const typesave = (data) => {
  return request({
    url: '/admin_cms/category/save',
    method: 'POST',
    data: data
  })
}

// 产品列表
export const getGoodsList = (data = {}) => {
  return request({
    url: '/admin_cms/goods/getlist',
    method: 'POST',
    data: data
  })
}

export const getGoodsEdit = (data = {}) => {
  return request({
    url: '/admin_cms/goods/edit',
    method: 'POST',
    data: data
  })
}

// 文章列表
export const getArticleListBy1 = (data = {}, type ='') => {
  if (type == 'system'){
    var url = '/admin_cms/recommend/wmRecommend'
  }else{
    var url = '/admin_cms/article/getlist'
  }
  return request({
    url: url,
    method: 'POST',
    params: data
  })
}

// 文章编辑
export const getArticleEdit = (data = {}) => {
  return request({
    url: '/admin_cms/article/edit',
    method: 'GET',
    params: data
  })
}

// 上一页，下一页
export const getPreNext = (data = {}) => {
  return request({
    url: '/admin/page/preNext',
    method: 'GET',
    params: data
  })
}

// 产品分类
export function proTypeList(data) {
  return request({
    url: '/admin_cms/goodsType/getlist',
    method: 'GET',
    params: data
  })
}

// 产品tab列表
export function getProducttablist(data) {
  return request({
    url: '/admin_cms/goodsTab/getlist',
    method: 'get',
    params: data
  })
}

// 新增产品
export function addProduct(data) {
  return request({
    url: '/admin_cms/goods/save',
    method: 'POST',
    data
  })
}

// 产品详情
export function proDetail(data) {
  return request({
    url: '/admin_cms/goods/edit',
    method: 'POST',
    data
  })
}

//图册分类
export function get_atlas_class() {
  return request({
    url: '/admin_cms/Category/getlist?type=5&hide=false',
  })
}

//文章列表
//文章编辑

export const getArticalInfo = (data) => {
  return request({
    url: '/admin_cms/article/edit',
    method: 'GET',
    params: data
  })
}
//文章保存

export const saveArtical = (data) => {
  return request({
    url: '/admin_cms/article/save',
    method: 'POST',
    data
  })
}

// 获取分类列表
export function getCategory(data) {
  return request({
    url: '/admin_cms/Category/getlist',
    method: 'get',
    params: data
  })
}

//文章分类详情
export const typedetail = (data) => {
  return request({
    url: '/admin_cms/category/edit',
    method: 'GET',
    params: data
  })
}

//产品分类详情
export function detailtype(data) {
  return request({
    url: '/admin_cms/goodsType/edit',
    method: 'GET',
    params: data
  })
}

//产品分类保存

export function saveProType(data) {
  return request({
    url: '/admin_cms/goodsType/save',
    method: 'POST',
    data
  })
}

//文章分类大保存

export function saveBothArticleType(data) {
  return request({
    url: '/admin_cms/category/saveAll',
    method: 'POST',
    data
  })
}

//产品分类大保存

export function saveBothProType(data) {
  return request({
    url: '/admin_cms/goodsType/saveAll',
    method: 'POST',
    data
  })
}

//通过分类获取产品或文章id
export const getIDlist = (data) => {
  return request({
    url: '/admin_cms/pub/getDataByCateID',
    method: 'GET',
    params: data
  })
}

//批量修改分类
export const changeListtype = (data) => {
  return request({
    url: '/admin_cms/pub/moveByCate',
    method: 'GET',
    params: data
  })
}
//文章分类删除
export const deltypeList = (data) => {
  return request({
    url: '/admin_cms/category/remove/',
    method: 'GET',
    params: data
  })
}
/**
 * 删除文章
 * ids 逗号分隔字符串
 */
export const deleteArtical = (data) => {
  return request({
    url: '/admin_cms/article/remove',
    method: 'GET',
    params: data
  })
}

// 产品批量删除
export function deletePro(data) {
  return request({
    url: '/admin_cms/goods/remove',
    method: 'POST',
    data
  })
}

// 删除产品分类
export function deleteProType(data) {
  return request({
    url: '/admin_cms/goodsType/remove',
    method: 'get',
    params: data
  })
}

//图册删除
export function delete_atlas(data) {
  return request({
    url: '/admin_cms/album/remove',
    method: 'get',
    params: data
  })
}

//获取单个挂件数据删除
export function getWidgetInfo(data) {
  return request({
    url: '/admin/visual/getWidgetInfo',
    method: 'get',
    params: data
  })
}

//模板上传
export function updoc(data) {
  return request({
    url: '/admin/visual/updoc',
  })
}

// 翻译
export function translate() {
  return request({
    url: '/admin/translate/theme',
    method: 'post'
  })
}

//复制挂件(跨页面)
export function copyWidget(data) {
  return request({
    url: '/admin/widget/copyWidget',
    method: 'get',
    params: data
  })
}

//设置关联挂件
export function setRelationWidget(data) {
  return request({
    url: '/admin/widget/setRelationWidget',
    method: 'get',
    params: data
  })
}

//获取关联关系
export function getRelationWidgetPage(data) {
  return request({
    url: '/admin/widget/getRelationWidgetPage',
    method: 'get',
    params: data
  })
}

//tyun控制台登录
export function loginConsole(data) {
  return console_login({
    url: '/tcloud-sso/account/loginConsole',
    method: 'POST',
    params: data
  })
}

// 新建站后台验证登录接口
export function nowCheckLogin(data) {
  return service({
    url: '/admin/login',
    method: 'get',
    params: data
  })
}

// 二次验证发送手机验证码(tyun控制台)
export function sendSecondValidPhoneSecode() {
  return console_login({
    url: '/tcloud-sso/account/sendSecondValidPhoneSecode',
    method: 'get'
  })
}

// 校验二次验证手机验证码(tyun控制台)
export function checkSecondValidPhoneSecode(params) {
  return console_login({
    url: '/tcloud-sso/account/checkSecondValidPhoneSecode',
    method: 'get',
    params
  })
}

//图片库相关接口
export function getImgStore(data) {
  return request({
    url: '/admin/image/xyslist',
    method: 'POST',
    params: data
  })
}

//清理缓存
export function clearStatic() {
  return request({
    url: '/admin/visual/clearStatic',
    method: 'get',
  })
}

//获取面包屑
export function getCrumbs(data) {
  return request({
    url: '/admin/navigation/crumbs',
    method: 'get',
    params: data
  })
}

// 获取分销商用户信息
export function getPlatformInfo(data) {
  return dcl_ajax({
    url: `/admin/platformInfo`,
    method: 'get',
    params: data
  })
}


//获取语音列表
export function getlanguageList(data) {
  return request({
    url: `/admin/language/list`,
    method: 'get',
    params: data
  })
}

//同步翻译页面
export function translatePage(data) {
  return request({
    url: `/admin/translate/syncPage`,
    method: 'POST',
    data
  })
}

//已经开通的语言
export function getOpenLangList() {
  return request({
    url: '/admin/language/list',
    method: 'get',
  })
}

//刷新token
export function refreshToken() {
  return request({
    url: '/admin/home/health',
    method: 'get',
    params: {
      token: Cookies.get('X-Token')
    }
  })
}

export function getJobList(data) {
  return request({
    url: '/admin/job/index',
    method: 'POST',
    data
  }).then((res) => {
    if (res.code !== 200) {
      this.$message.error(res.message);
    }
    let jobTypeMap = {
      1: i18n.t('api_app_598'),
      2: i18n.t('api_app_599')
    }
    res.data.data.forEach((job) => {
      job.jobType = jobTypeMap[job.nature_type]
      job.endTime = job.exp_date_end ? moment(new Date(job.exp_date_end * 1000)).format('YYYY-MM-DD HH:mm:ss') : job.exp_date_end
    })
    res.data.data = res.data.data.filter((job) => {
      const statusOpen = 1
      return job.status === statusOpen
    })
    return res
  })
}

export function getResumeColumn(data) {
  return request({
    url: '/admin/resume/resumeColumn',
    method: 'get',
    data
  })
}

export function createFont(data) {
  return request({
    url: '/admin/font/createFont',
    method: 'POST',
    data
  })
}

export function getFontStyle(data) {
  return request({
    url: '/admin/font/getFontStyle',
    method: 'get',
    params: data
  })
}

export function getFreeFontList(data) {
  return request({
    url: '/admin/font/getFreeFontList',
    method: 'get',
    params: data
  })
}

export function getFontList() {
  return request({
    url: '/admin/font/originFontList',
    method: 'get',
  })
}

export function saveFontList(data) {
  return request({
    url: '/admin/font/saveFont',
    method: 'POST',
    data
  })
}

//获取网站备案信息
export function getIcpInfo(data) {
  return request({
    url: '/admin_cms/pub/siteFiling',
    method: 'get',
    params: data
  })
}

// 设置链接里面 获取邮箱地址
export function getMailConfig() {
  return request({
    url: 'admin/sysConfig/mailConfig',
    method: 'get'
  })
}

// 获取开启的登录方式 admin/sysconfig/userLoginConfig
export function getUserLoginWay() {
  return request({
    url: 'admin/sysconfig/userLoginWay',
    method: 'get'
  })
}

export function getUserRegConfig(data) {
  return request({
    url: '/admin/sysconfig/userRegConfig',
    method: 'get',
    params: data
  })
}

//  热门推荐分类 type
export function getRecommendType(data) {
  return request({
    url: '/admin/keyword/selTag',
    method: 'get'
  })
}
//  热门推荐列表
export function getRecommendList(data) {
  return request({
    url: '/admin/keyword/relationContentList',
    method: 'post',
    data
  })
}
//  分类挂件中的导航列表
export function widgetNavList(data) {
  return request({
    url: '/admin/navigation/widgetNavList',
    method: 'get',
    params: data
  })
}
// 获取标签列表
export const getTagsList = () => {
  return request({
    url: '/admin_cms/Tag/getList',
    method: 'GET'
  })
}
// 获取帮助文档链接地址
export function getHelpLink(data) {
  return console_login({
    url: '/aggregateservice-web/api/Home/Help',
    method: 'post',
    data
  })
}

// 获取语言列表
export function getLangs(data) {
  return request({
    url: '/admin/language/getLangs',
    method: 'get',
    params: data
  })
}

// 是否有Fshop权益
export function getFshopRole() {
  return request({
    url: '/admin_b2c/Server/getFshop',
    method: 'get'
  })
}

// admin_b2c/Server/getShopRole
export function getShopRole() {
  return request({
    url: '/admin_b2c/Server/getShopRole',
    method: 'get'
  })
}

// 查询权益和数量的接口
export function gptUsageCount() {
  return console_login({
    url: '/ai-article/gpt/history/usageCount',
    method: 'get'
  })
}


// 获取指令
export function getAiCommand(data) {
  return request({
    url: `/admin/theme/getAiCommand`,
    method: 'post',
    data
  })
}

// 分割内容
export function splitAiContent(data) {
  return request({
    url: `/admin/aiArticle/splitAiContent`,
    method: 'post',
    data
  })
}
//获取站点配置
export function siteConfig(params) {
  return request({
    url: `admin/SysConfig/siteConfig`,
    method: 'get',
    params
  })
}

export function saveReplaceWords(data) {
  return request({
    url: `/admin/ReplaceWords/saveReplaceWords`,
    method: 'post',
    data
  })
}

export function getReplaceWords(params) {
  return request({
    url: `/admin/ReplaceWords/getReplaceWords`,
    method: 'get',
    params
  })
}

export function getLanglist() {
  return console_login({
    url: '/obor-nginx-php-ydyl/api/pc/getLanglist',
    method: 'get'
  })
}

// 获取语言导航列表
export function getLangNavList(data) {
  return request({
    url: '/admin/language/getLangNavList',
    method: 'get',
    params: data
  })
}

// 保存语言导航列表
export function saveLangNavList(data) {
  return request({
    url: '/admin/language/saveLangNavList',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/app.js